/**
 * @format
 * @module lib/gamservices
 * @description Store Usermanagement API endpoint urls and related settings.
 * @see https://gamservices.stg.theglobeandmail.com/usermanagement/swagger-ui.html
 * @see https://tgamuserprofile.theglobeandmail.ca/swagger-ui.html
 * @see https://myglobe-dev.theglobeandmail.com/swagger-ui.html
 */

import tgamConfig from "config/tgam";

export const API_HOST = `https://${tgamConfig.env.gamDomain}.${tgamConfig.env.wwwDomain}/usermanagement`;

export const API_TIMEOUT = 3000;

// User Controller
export const API_PROFILE = `${API_HOST}/api/v3/user`;
export const API_ANALYTICS = `${API_HOST}/api/v3/user/analytics`;

// Newsletter Controller
export const API_NEWSLETTERS = `${API_HOST}/api/v3/user/newsletters`;

// Log front-end events
export const API_LOG_EVENT = `${API_HOST}/api/v3/sites/log`;

// Event Controller
export const API_EVENTS = `${API_HOST}/public/v1`;

// Third Party Controller
export const API_PUBLIC_ENCRYPT = `${API_HOST}/public/v3/encrypt`;
export const API_PUBLIC_DECRYPT = `${API_HOST}/public/v3/decrypt`;
export const API_PUBLIC_SSO = `${API_HOST}/public/v3/user/sso`;

// PageBuilder API (relative url)
export const API_PB_RENDER_FEATURE = "/pb/api/v2/render/feature";

// Data Science API - User Profile
const USER_PROFILE = "https://tgamuserprofile.theglobeandmail.ca";
export const API_DS_USER_REGION = `${USER_PROFILE}/upcj/getregion`;
export const API_DS_CONTENT_LIKE = `${USER_PROFILE}/content/like`;
export const API_DS_USER_READING_HISTORY = `${USER_PROFILE}/upcj/readinghistory`;
export const API_DS_EXTENDED_USER_PROFILE = `${USER_PROFILE}/main/`;
export const API_DS_ANON_USER_PROFILE = `${USER_PROFILE}/main/anonymoususerprofile`;
export const API_DS_USER_SECTIONS = `${USER_PROFILE}/upcj/getsections`;

// Data Science API - Audio
export const API_DS_AUDIO =
  "https://pc81apbdk0.execute-api.us-east-1.amazonaws.com/default/FileLocator";

export const API_DS_AUDIO_LIST =
  "https://8tpm017v2b.execute-api.us-east-1.amazonaws.com/default/filelocatordev2";

// Data Science API - Misc
export const API_DS_DYNAMIC_PAYWALL = `https://${
  tgamConfig.env.isProdOrStage ? "hermes" : "dynpw-dev"
}.theglobeandmail.com`;

export const API_DS_SMARTWALL = `https://${
  tgamConfig.env.isProdOrStage ? "smartwall" : "smartwall-dev"
}.theglobeandmail.com/v1`;

const MY_GLOBE_USER = `https://${
  tgamConfig.env.isProdOrStage ? "myglobe-prd" : "myglobe-dev"
}.theglobeandmail.com/v1/user`;

// Data Science API - Topics
export const API_TOPICS_CHECK_BY_ID = `${MY_GLOBE_USER}/topic/check`; // Checks whether topic(s) exists based on topic ID or slug
export const API_TOPICS_CHECK_BY_SLUG = `${MY_GLOBE_USER}/topic/checkbyslug`; // Checks whether topic(s) exists based on topic ID or slug
export const API_TOPICS_FOLLOW = `${MY_GLOBE_USER}/topic/follow`; // Follows a topic for a given user
export const API_TOPICS_UNFOLLOW = `${MY_GLOBE_USER}/topic/unfollow`; // Unfollows a topic for a given user
export const API_AUTHOR_FOLLOW = `${MY_GLOBE_USER}/author/follow`; // Follows an author for a given user
export const API_AUTHOR_UNFOLLOW = `${MY_GLOBE_USER}/author/unfollow`; // Unfollows an author for a given user
export const API_TOPICS_TRENDING = `${MY_GLOBE_USER}/topic/trending`; // Fetch trending topics for a given user
export const API_TOPICS_AND_ARTICLES = `${MY_GLOBE_USER}/topics`; // Get followed topics and latest articles under those topics for a given user
export const API_TOPICS_ALL_FOLLOWED = `${MY_GLOBE_USER}/alltopics`; // Fetch all topics that the given user is following
export const API_TOPICS_LATEST = `${MY_GLOBE_USER}/topicarticles`; // Get followed topics and latest articles under those topics for a given user
export const API_TOPICS_RECOMMENDED = `${MY_GLOBE_USER}/topic/recommendation`; // Fetch recommended topics and authors for a given user
export const API_TOPICS_UNREAD = `${MY_GLOBE_USER}/topicarticles/count`; // Fetch the number of unread stories for a given user

// Search for topics
export const API_TOPICS_SEARCH = `https://${
  tgamConfig.env.isProdOrStage ? "yx2ln9gx79" : "x43l66z4n3"
}.execute-api.ca-central-1.amazonaws.com/${
  tgamConfig.env.isProdOrStage ? "prod" : "dev"
}/search-topics.json`;

// Union Station API
export const API_UNION = "https://recoapi-prd.theglobeandmail.ca/v2/recommendations";
